export default "__VITE_ASSET__wzo6MAV$__"